import {Box, Text} from "@chakra-ui/react";

const InfoBubble = ({message}) => {
    return (
        <Box display={'flex'} justifyContent={'center'} w={'full'} py={2}>
            <Box bg={'gray.900'} borderWidth={1} borderColor={'border.primary'} color={'white'} borderRadius={'md'} p={3} maxW={'80%'}>
                <Text fontSize={14} whiteSpace="pre-wrap">{message.text}</Text>
            </Box>
        </Box>
    );
};

export default InfoBubble;
